import { buildSchema } from "@camberi/firecms";

export const generalSettingSchema = buildSchema({
    name: "General Settings",
    properties: {
        cookie_privacy: {
            title: "Cookie Privacy",
            dataType: "string"
        },
        payment_price_unit: {
            title: "Price Per Unit",
            dataType: "string"
        },
        profile_placeholder: {
            title: "Profile Placeholder",
            dataType: "string"
        },
        support_email: {
            title: "Support Email",
            dataType: "string"
        },
        terms_and_cond_url: {
            title: "Terms and Condition Url",
            dataType: "string"
        },
        play_store_link: {
            title: "Play Store Link",
            dataType: "string"
        },
        apple_store_link: {
            title: "Apple Store Link",
            dataType: "string"
        },
        login_image: {
            title: "Login Image",
            dataType: "string"
        },
        copyright_text: {
            title: "Copyright Text",
            dataType: "string"
        },
        referral_points_value: {
            title: "Referral Points Value",
            dataType: "number",
            columnWidth: 200,
        },
        enable_re_engagement: {
            title: "Enable Re-Engagement Email",
            dataType: "boolean",
            columnWidth: 250,
        },
        first_engagement_email: {
            title: "First Re-Engagement Email Days",
            dataType: "number",
            columnWidth: 250,
        },
        second_engagement_email: {
            title: "Second Re-Engagement Email Days",
            dataType: "number",
            columnWidth: 250,
        },
        monthly_discount_percentage: {
            title: "Monthly Discount Percentage",
            dataType: "number",
            columnWidth: 200,
        },
        quarterly_discount_percentage: {
            title: "Quarterly Discount Percentage",
            dataType: "number",
            columnWidth: 250,
        },
        feedback_interval: {
            title: "Feedback Interval (In Days)",
            dataType: "number",
            columnWidth: 250,
        },
        one_to_one_created_id: {
            title: "One To One Created ID",
            dataType: "boolean",
            columnWidth: 250,
        },
        one_to_one_customer_id: {
            title: "One To One Customer ID",
            dataType: "boolean",
            columnWidth: 250,
        },
        one_to_one_fee_enable: {
            title: "Enable One To One Fee",
            dataType: "boolean",
            columnWidth: 250,
            disabled: true,
            readOnly: true
        },
    },
    defaultValues: {
        first_engagement_email: 10,
        second_engagement_email: 20,
        monthly_discount_percentage: 25,
        quarterly_discount_percentage: 50,
    }
});
